import { MouseoverTooltip } from 'components/Tooltip'
import { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'

import * as S from './styled'

const HeaderRow = () => {
  const theme = useContext(ThemeContext)

  return (
    <thead>
      <tr>
        <S.Th width="25.6%" style={{ textAlign: 'left' }}>
          <MouseoverTooltip
            text={
              <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
                User Concentrated Liquidity Position
              </ThemedText.DeprecatedBody>
            }
          >
            <ThemedText.DeprecatedBody
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color={theme.textSecondary}
              className="title"
            >
              Position
            </ThemedText.DeprecatedBody>
          </MouseoverTooltip>
        </S.Th>

        <S.Th width="16.6%" style={{ textAlign: 'left' }}>
          <MouseoverTooltip
            text={
              <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
                Range in which liquidity is deployed
              </ThemedText.DeprecatedBody>
            }
          >
            <ThemedText.DeprecatedBody
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color={theme.textSecondary}
              className="title"
            >
              Range
            </ThemedText.DeprecatedBody>
          </MouseoverTooltip>
        </S.Th>

        <S.Th width="13.6%" style={{ textAlign: 'left' }}>
          <MouseoverTooltip
            text={
              <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
                Current pool price
              </ThemedText.DeprecatedBody>
            }
          >
            <ThemedText.DeprecatedBody
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color={theme.textSecondary}
              className="title"
            >
              Price
            </ThemedText.DeprecatedBody>
          </MouseoverTooltip>
        </S.Th>

        <S.Th width="12.6%" style={{ textAlign: 'left' }}>
          <MouseoverTooltip
            text={
              <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
                User deposits
              </ThemedText.DeprecatedBody>
            }
          >
            <ThemedText.DeprecatedBody
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color={theme.textSecondary}
              className="title"
            >
              My Deposits
            </ThemedText.DeprecatedBody>
          </MouseoverTooltip>
        </S.Th>

        <S.Th width="16.6%" style={{ textAlign: 'left' }}>
          <MouseoverTooltip
            text={
              <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
                Accrued but not yet claimed fees
              </ThemedText.DeprecatedBody>
            }
          >
            <ThemedText.DeprecatedBody
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color={theme.textSecondary}
              className="title"
            >
              Unclaimed Fees
            </ThemedText.DeprecatedBody>
          </MouseoverTooltip>
        </S.Th>

        <S.Th width="16.6%" style={{ textAlign: 'left' }}>
          <MouseoverTooltip
            text={
              <ThemedText.DeprecatedBody fontSize="12px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
                Click to add or remove liquidity
              </ThemedText.DeprecatedBody>
            }
          >
            <ThemedText.DeprecatedBody
              fontSize="16px"
              fontWeight="700"
              lineHeight="24px"
              color={theme.textSecondary}
              className="title"
            >
              Manage
            </ThemedText.DeprecatedBody>
          </MouseoverTooltip>
        </S.Th>
      </tr>
    </thead>
  )
}

export default HeaderRow
